const GetConfigIcon = (tags) =>
  tags.filter((tag) => tag.id === "plot").length > 0
    ? "/images/icons/property/plot.svg"
    : tags.filter((tag) => tag.id === "villa").length > 0
      ? "/images/icons/property/villa.svg"
      : tags.filter((tag) => tag.id === "building").length > 0
        ? "/images/icons/property/building.svg"
        : tags.filter((tag) => tag.id === "apartment").length > 0
          ? "/images/icons/config/living_room.svg"
          : "/images/icons/config/living_room.svg";
export default GetConfigIcon;
